export default function extractProjectIdFromName(projectName, projectLists) {
  const project = projectLists.filter((project) => {
    if (project.name.includes(projectName)) {
      return project
    }
  })
  const projectId = project[0].id
  return projectId
}
